import React, { useState } from 'react';
import { Badge } from 'react-bootstrap';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import { Anchor } from '../../components/Anchor';
import { Button } from '../../components/Button';

import { Coupon } from '../../reducers/coupons';

type CouponRowProps = {
  coupon: Coupon;
};

export const CouponRow = ({ coupon }: CouponRowProps) => {
  const [copied, setCopied] = useState(false);

  return (
    <tr>
      <td>
        <strong>{coupon.coupon_codice}</strong>

        <div className={'mt-2'}>
          {copied ? (
            <Badge variant={'success'}>Codice copiato!</Badge>
          ) : (
            <CopyToClipboard
              text={coupon.coupon_codice}
              onCopy={() => setCopied(true)}
            >
              <Button>Copia codice sconto</Button>
            </CopyToClipboard>
          )}
        </div>
      </td>
      <td>{coupon.coupon_info_titolo}</td>
      <td>
        <Anchor href={coupon.coupon_info_link}>
          Clicca qui per utilizzare il tuo coupon
        </Anchor>
      </td>
    </tr>
  );
};
